module.exports = __webpack_public_path__ + "static/wsp-064d7850be04da39b86a38f45e80916f.png";